import { render, staticRenderFns } from "./monitoring-data-tabel.vue?vue&type=template&id=16d9dbaf&scoped=true"
import script from "./monitoring-data-tabel.vue?vue&type=script&lang=js"
export * from "./monitoring-data-tabel.vue?vue&type=script&lang=js"
import style0 from "./monitoring-data-tabel.vue?vue&type=style&index=0&id=16d9dbaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d9dbaf",
  null
  
)

export default component.exports